import React, { Component } from "react";
import ReactDOM from "react-dom";
class ProductPopularityEvent extends Component {
  constructor(props) {
    super(props);
    this.state = { count: this.props.count };
  }

  componentDidMount() {
    if (this.props.liveRecalculation === true) {
      setInterval(this.recalculateAmmount(this.props.count), 5000);
    }
  }
  render() {
    return (
      <div className={this.props.className}>
        <span>
          {this.props.text} {this.state.count}
        </span>
      </div>
    );
  }

  recalculateAmmount(defaultCount) {
    let recount;
    switch (true) {
      case defaultCount >= 30:
        recount = defaultCount + (Math.floor(Math.random() * 7) - 3);
        break;
      case defaultCount >= 10:
        recount = defaultCount + (Math.floor(Math.random() * 5) - 2);
        break;
      default:
        recount = defaultCount + (Math.floor(Math.random() * 3) - 1);
        break;
    }

    if (recount > 0) {
      this.setState({
        count: recount,
      });
    }

    return true;
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const onlineEventsRoot = document.querySelector("#online-viewers");

  if (onlineEventsRoot instanceof HTMLElement) {
    const text = onlineEventsRoot.dataset.text;
    const count = onlineEventsRoot.dataset.count;
    const className = onlineEventsRoot.dataset.classname;

    ReactDOM.render(
      <ProductPopularityEvent
        text={text}
        count={count}
        className={className}
        liveRecalculation={true}
      />,
      document.getElementById("online-viewers")
    );
  }

  const totalOrdersRoot = document.querySelector("#total-orders");

  if (totalOrdersRoot instanceof HTMLElement) {
    const text = totalOrdersRoot.dataset.text;
    const count = totalOrdersRoot.dataset.count;
    const className = totalOrdersRoot.dataset.classname;

    ReactDOM.render(
      <ProductPopularityEvent
        text={text}
        count={count}
        className={className}
        liveRecalculation={false}
      />,
      document.getElementById("total-orders")
    );
  }
});
